import { expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
import React, { useEffect, useState } from 'react'
import configData from "../../../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import CardAcuerdoMediosElectronicos from "components/Varios/CardAcuerdoMediosElectronicos.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import ModalFirmarPDF from 'components/Varios/Modals/ModalFirmarPDF';

import { authenticationService } from '../../../services/authentication.service';
import axios, { AxiosRequestConfig } from 'axios';

const id = 1043;
const API_URL = configData.SERVER_URL;

export class AcuerdoMediosElectronicosData {
    idotrosdocumentos: number = 0;
    idpersona: number = 0;
    tipodoc: string = "";
    codigodocumento: string = "";
    refdoc: string = "";
    fecharegistro: string = "";
    estado: string = "";
    Estadorevisionth: number = 0;
}

interface AcuerdoMediosElectronicosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: AcuerdoMediosElectronicosData;
    AcuerdoMediosElectronicosList: AcuerdoMediosElectronicosData[];
    error: null;
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    urlPDF: string;
    loadingPDF: boolean;
    isOpenModal: boolean;
}

export class AcuerdoMediosElectronicos extends React.Component<RouteComponentProps, AcuerdoMediosElectronicosDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new AcuerdoMediosElectronicosData(),
            AcuerdoMediosElectronicosList: [], error: null, tiposEvidencia: [], filesData: [], urlPDF: "", loadingPDF: false, isOpenModal: false
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.vistaPrevia = this.vistaPrevia.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    vistaPrevia(key) {

        if (key === "VistaPrevia") {
            alertService.clear();

            const data = JSON.stringify({
                "idpersona": this.state.currentUser.idpersona
            });

            var btnVistaPrevia = document.getElementById("btnVistaPrevia");
            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            if (btnVistaPrevia != null) {
                btnVistaPrevia.textContent = " Cargando . . . ";
                btnVistaPrevia.insertBefore(i, null)
                btnVistaPrevia.setAttribute("disabled", "true");
            }

            fetch(API_URL + "AcuerdoMediosElectronicos/VistaPrevia", {

                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,

            })
                .then(response => {
                    response.blob()
                        .then(blob => {
                            let url = window.URL.createObjectURL(blob);

                            var loadingEnviar = document.getElementById("loadingEnviar");
                            if (loadingEnviar != null) {
                                var parentNode = loadingEnviar.parentNode;
                                if (parentNode != null) {
                                    parentNode.removeChild(loadingEnviar);
                                }
                            }
                            var btnVistaPrevia = document.getElementById("btnVistaPrevia");
                            if (btnVistaPrevia != null) {
                                btnVistaPrevia.textContent = "Firmar Acuerdo de Medios Eléctronicos";
                                btnVistaPrevia.removeAttribute("disabled");
                            }

                            this.setState({ urlPDF: url, isOpenModal: true });

                        });
                }
                )

        }
    }

    async FirmarDocumentoAutorizar(objeto: any) {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        if (contrasenia && filesData.length > 0) {
            var datosRequest = new FormData();
            datosRequest.append("contrasenia", contrasenia);
            datosRequest.append("idpersona", this.state.currentUser.idpersona);
            filesData.map((fData) => {
                datosRequest.append("files", fData.file, fData.file.name);
            });

            this.handleSaveFirmar(datosRequest);
        }
    }

    private async handleSaveFirmar(datosRequest: FormData) {

        var currentUser = authenticationService.currentUserValue;

        let instance = axios.create();
        let options: AxiosRequestConfig = {
            url: API_URL + "AcuerdoMediosElectronicos/FirmarAcuerdo",
            data: datosRequest,
            method: "POST",
            headers: {
                Authorization: `KEYESPOL ${currentUser?.token}`
            }
        };
        try {
            await instance.request<any>(options).then((response) => {
                var result = response.data;
                if (result["strEstado"] === "N") {
                    alertService.error(result["strMensaje"]);
                }
                else if (result["strEstado"] === "S") {
                    alertService.success("Se firmó el acuerdo de medios electrónicos.");
                }
                else {
                    alertService.error("Ocurrió un error: " + result);
                }
                this.cargarDatos();

                var loadingEnviar = document.getElementById("loadingEnviar");
                if (loadingEnviar != null) {
                    var parentNode = loadingEnviar.parentNode;
                    if (parentNode != null) {
                        parentNode.removeChild(loadingEnviar);
                    }
                }
            });

        }
        catch (error) {
            alertService.error("Ocurrió un error: " + error);
        }
        this.setState({ urlPDF: "" });

    }

    cargarDatos() {
        this.setState({
            loading: false,
            loadingList: false
        });
        fetch(API_URL + "AcuerdoMediosElectronicos/AcuerdoMediosElectronicosDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            AcuerdoMediosElectronicosList: result.entTabla,
                            loading: false,
                            loadingList: false
                        });

                        if (this.state.AcuerdoMediosElectronicosList.length > 0) {
                            var botonvistaprevia = document.getElementById("btnVistaPrevia");
                            //if (botonvistaprevia != null) botonvistaprevia.setAttribute("disabled", "true");
                            if (botonvistaprevia != null) botonvistaprevia.setAttribute("hidden", "hidden");
                        }
                        else {
                            var botonvistaprevia = document.getElementById("btnVistaPrevia");
                            //if (botonvistaprevia != null) botonvistaprevia.setAttribute("disabled", "true");
                            if (botonvistaprevia != null) botonvistaprevia.removeAttribute("hidden");
                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.");
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        AcuerdoMediosElectronicosList: []
                    });
                    alertService.error("Ocurrió un error: " + error);
                }
            )
    }

    descargarEvidencias(acuerdo: AcuerdoMediosElectronicosData) {
        var evidencias = new Array();
        if (acuerdo.refdoc) {
            evidencias.push({ name: "ACUERDO-" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "AcuerdoMediosElectronicos/Refarchivo/" + acuerdo.idotrosdocumentos });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new AcuerdoMediosElectronicosData() });
    }

    onClickDelete(idotrosdocumentos) {
        fetch(API_URL + "AcuerdoMediosElectronicos/DeleteAcuerdoMediosElectronicos/" + idotrosdocumentos, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"]);
                    }
                    else {
                        alertService.success("El acuerdo de medios electrónicos se anuló correctamente.");
                        this.cargarDatos();
                    }
                })
    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.AcuerdoMediosElectronicosList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.

    private renderForm(AcuerdoMediosElectronicosList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Acuerdo de Medios Eléctronicos</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <Row>
                                        <Col md={12}>
                                            <Button id="btnVistaPrevia" color="primary" type="button" className="btn btn-default ml-2" style={{ float: "left" }} onClick={() => this.vistaPrevia("VistaPrevia")}>Firmar Acuerdo de Medios Eléctronicos</Button>

                                        </Col>
                                    </Row>
                                    <br />

                                    <ModalFirmarPDF
                                        show={(this.state.urlPDF !== undefined && this.state.urlPDF !== "") || this.state.loadingPDF}
                                        tituloModal='Acuerdo de Medios Electrónicos'
                                        admiteFirmaFisica={false}
                                        size="xl"
                                        urlArchivo={this.state.urlPDF}
                                        onClose={() => this.setState({ urlPDF: "" })}
                                        cargandoDatos={this.state.loadingPDF}
                                        onClickFirma={async (objeto) => await this.FirmarDocumentoAutorizar(objeto)}

                                    />

                                    <br />

                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {AcuerdoMediosElectronicosList.map((dto, index) =>
                                                <CardAcuerdoMediosElectronicos
                                                    key={dto.idotrosdocumentos}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + AcuerdoMediosElectronicosList.length}
                                                    eventDelete={() => this.onClickDelete(dto.idotrosdocumentos)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default AcuerdoMediosElectronicos;
